import { useCallback, useState } from "react";
import type { TableFilterDto } from "@gatiq/shared";
import { FilterSelect } from "@/ui";

export function useListFilters(resetPage: () => void) {
  const [values, setValues] = useState<Record<string, string>>({});
  const encoded = JSON.stringify(values);
  const apply = useCallback((params: URLSearchParams) => {
    params.set("includeFilters", "1");
    if (encoded !== "{}") params.set("filters", encoded);
  }, [encoded]);
  const change = (key: string, value: string) => {
    resetPage();
    setValues((previous) => {
      const next = { ...previous };
      if (value) next[key] = value; else delete next[key];
      return next;
    });
  };
  const clear = () => { resetPage(); setValues({}); };
  return { values, apply, change, clear };
}

export function ListFilters({ definitions = [], filters }: {
  definitions?: TableFilterDto[];
  filters: ReturnType<typeof useListFilters>;
}) {
  return <>
    {definitions.filter((definition) => definition.key !== "role" || definition.options.length > 1).map((definition) => <FilterSelect key={definition.key} label={definition.label}
      value={filters.values[definition.key] ?? ""} options={definition.options}
      onChange={(value) => filters.change(definition.key, value)} />)}
    {Object.keys(filters.values).length > 0 && <button type="button" className="text-xs font-medium text-brand-ink hover:underline" onClick={filters.clear}>Clear filters</button>}
  </>;
}
